import { RoleService } from "./../../views/organization/role/role.service";
import _ from "lodash";
import Cookies from "js-cookie";
import {
  computed,
  defineComponent,
  onMounted,
  PropType,
  reactive,
  nextTick,
  toRefs,
  watch,
  onActivated,
  ref,
} from "vue";

import { useEventbus } from "@/core";
import { bindEmitter } from "@/utils/emitter";
import Icon, { UserOutlined, ForkOutlined } from "@ant-design/icons-vue";
import { Form, message } from "ant-design-vue";
import { RolePageReq } from "@/views/organization/role/role.interface";
/**
 * 角色选择器
 *
 * <user-select v-model:value="formRef.userIds"></user-select>
 */
export default defineComponent({
  isGlobal: true,
  name: "RoleSelect",
  components: { UserOutlined, ForkOutlined },
  props: {
    value: {
      type: [String, Array] as PropType<string | string[]>,
      default: "",
    },
    disabled: { type: Boolean, default: false },
    maxCount: { type: Number, default: 1 },
  },
  emits: ["update:value", "change", "close"],
  setup(props, { emit }) {
    const state = reactive(<
      {
        visible: boolean;
        selectedRoles: any[];
        selectedRoleIds: any[];
        rolesData: any[];
        tempRoles: any[];
      }
    >{
      visible: false,
      selectedRoles: [],
      selectedRoleIds: [],
      rolesData: [],
      tempRoles: [],
    });
    const activeKey = ref("2");
    const columns = [
      {
        title: "角色名称",
        width: 250,
        dataIndex: "name",
        key: "name",
      },
      {
        title: "角色描述",
        width: 350,
        dataIndex: "description",
        key: "description",
      },
    ];
    const tableRef=ref()
    const showModal = async () => {
      if (props.disabled) return;
      state.visible = true;
      nextTick(()=>{
        if(tableRef&&tableRef.value){
          tableRef.value.xTable1?.setCheckboxRow(state.selectedRoles, true)
        }
      })
    };
    const onSelectionChange = (ids: []) => {
      // console.log("🚀 ~ file: role-select.controller.ts:69 ~ onSelectionChange ~ ids:", ids);
      state.selectedRoleIds = ids;
    };
    const triggerUpdate = () => {
      // const ids = state.tempUsers.map((o: any) => o.id);
      // if (state.tempUsers.length === 0) {
      //   emit("update:value", props.maxCount > 1 ? [] : "");
      //   emit("change", state.tempUsers);
      //   return;
      // }
      // emit("update:value", props.maxCount > 1 ? ids : ids[0]);
      // emit("change", state.tempUsers);
    };

    const ok = () => {
      if (props.maxCount && state.selectedRoleIds.length > props.maxCount) {
        message.warn(`最多只能选择${props.maxCount}个`);
        return;
      }
      state.selectedRoles = (state.rolesData.filter((r: any) =>
        state.selectedRoleIds.includes(r.id)
      ) || []) as any;
     
      emit("update:value", props.maxCount > 1 ? state.selectedRoleIds : state.selectedRoleIds[0]);
      state.visible = false;
    };
    const setSelectedRoles =async (datas) => {      
      const ids = _.isArray(datas) ? datas : [datas];
      if (ids.length == 0) {
        state.tempRoles = [];
        state.selectedRoleIds = [];
        state.selectedRoles = [];
        return;
      } else {
        if(state.rolesData.length==0){
          await loadRoles()
        }
        state.selectedRoleIds = ids;
        state.tempRoles = (state.rolesData.filter((r: any) =>
          state.selectedRoleIds.includes(r.id)
        ) || []) as any;
        state.selectedRoles = [...state.tempRoles]
      }
    };

    const deleteTempUser = (deletedId) => {
      // state.tempUsers = state.tempUsers.filter((item) => item.id !== deletedId);
    };

    const deleteSelectedUser = (deletedId) => {
      state.selectedRoles=state.selectedRoles.filter((item) => item.id !== deletedId);
      state.selectedRoleIds=state.selectedRoleIds.filter((item) => item !== deletedId);
      emit("update:value", props.maxCount > 1 ? state.selectedRoleIds : state.selectedRoleIds[0]);
      // state.tempUsers = state.tempUsers.filter((item) => item.id !== deletedId);
      // state.tempUsers.length == 0 && (state.isError = true);
      // triggerUpdate();
      // emit("close", "");
    };

    const { run: runRole, loading } = RoleService.usePageApi();
    const queryRef = reactive(new RolePageReq());
    const loadRoles = async () => {
      queryRef.current = 1;
      queryRef.size = 10000;
      const res = await runRole(queryRef);
      state.rolesData = (res.data?.records || []) as any;
    };

    watch(
      () => props.value,
      (n) => {
        if (!props.value) {
          state.tempRoles = [];
          state.selectedRoleIds = [];
          state.selectedRoles = [];
        } else {
          setSelectedRoles(n || []);
        }
      },
      { deep: true,immediate:true }
    );

    onMounted(async () => {
      await loadRoles();
    });
    onActivated(() => {});
    return {
      ...toRefs(state),
      showModal,
      ok,
      deleteTempUser,
      deleteSelectedUser,
      activeKey,
      columns,
      onSelectionChange,
      loading,
      tableRef
    };
  },
});
